import React from 'react';

import { Loader } from '../../components/Loader';

import { LoadingViewContainer } from './styledComponents';

class LoadingView extends React.Component {
  render() {
    return (
      <LoadingViewContainer className="loading-view-container">
        <Loader height={40} width={40} />
      </LoadingViewContainer>
    );
  }
}

export { LoadingView };
